module.exports = __webpack_public_path__ + "img/ableton-live-oscleton-control-surface-screenshot.f4c692dc.png";